import { useMutation, useQueryClient } from "@tanstack/react-query";

import { variantAttributeKeys } from "./keys";

import { isMockEnabled, simulateDelay } from "@/mock/config";
import { deleteVariantAttributeMock } from "@/mock/handlers/variant-attribute";

import { api } from "@/lib/api-client";

export const useDeleteVariantAttribute = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      if (isMockEnabled()) {
        await simulateDelay();
        const result = deleteVariantAttributeMock(id);
        if (!result) throw new Error("Variant attribute not found");
        return true;
      }

      await api.delete(`variant-attributes/${id}`);

      return true;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: variantAttributeKeys.lists(),
      });
    },
  });
};
